import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoadingBarModule } from '@ngx-loading-bar/core';

import { SharedModule } from '../../shared/shared.module';

import {
  ReportsComponent,
  ReportsListComponent
} from './'

@NgModule({
  declarations: [
    ReportsComponent,
    ReportsListComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    LoadingBarModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class ReportsModule { }
